import { InjectionToken } from '@angular/core';

/**
 * @whatItDoes ç» `ui-select`ã`ui-input[type=date]` ç»ä»¶çä¸æç®­å¤´ç html åç´  class çåå­ç token
 *
 * ä½ å¯ä»¥éè¿ provide å®ä¹èªå·±çä¸æç®­å¤´ class
 *
 * @howToUse
 * ```typescript
 * import { NgModule } from '@angular/core';
 * import { UI_SELECT_ARROW_CLASSNAME } from '@tanbo/ui-native';
 *
 * @NgModule({
 *   ...
 *   providers: [{
 *     provide: UI_SELECT_ARROW_CLASSNAME,
 *     useValue: 'custom-classname'
 *   }]
 * })
 * export class AppModule {
 * }
 * ```
 */
export const UI_SELECT_ARROW_CLASSNAME = new InjectionToken<string>('UI_SELECT_ARROW_CLASSNAME');

/**
 * æè¡¨ååç´ çè¾å¥å±æ§è½¬æ boolean ç±»å
 * '' => true
 * 0 => false
 * null => false
 * undefined => false
 *
 * @param value
 * @returns boolean
 */
export function inputAttrToBoolean(value: any) {
  return value === '' || !!value;
}
